import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';

// Styles.
import styles from './DashboardWidget.module.scss';

export interface IDashboardWidgetProps {
  className?: string;
  isLoading?: boolean;
  overrideCssClassName?: string;
}

export const DashboardWidget = (props: PropsWithChildren<IDashboardWidgetProps>): ReactElement => {
  const { className, children, isLoading, overrideCssClassName } = props;
  const cssClassName = !overrideCssClassName ? styles.widget : styles[overrideCssClassName];
  const widgetClassNames = classNames(cssClassName, { [styles.loading]: isLoading }, className);

  return <div className={widgetClassNames}>{isLoading ? <CircularProgress color="inherit" /> : children}</div>;
};
